module.exports = __webpack_public_path__ + "static/media/station_download.090ff01f.svg";